<template>
  <div>
    <div
      class="trip-textarea to-right"
      v-if="extraInformation.length > 0"
    >
      <h3
        class="text-center main-ride-titles">
        {{ t('generalInfo') }}
      </h3>

      <div
        class="trip-textarea to-right"
        v-for="(rideExtraInformation, index) in extraInformation"
        :key="index"
      >
        <p
          class="extra-information-title">
          {{rideExtraInformation.title}} <br>
        </p>
        <a
          v-if="canEdit"
          class="trip-default-btn width-150" @click="editExtraInformation( rideExtraInformation.id)"
        >
                        {{ t('edit') }}
        </a>
        <CollapseText
          class="ride-detailes"
          :text="rideExtraInformation.text"
          :uniqueId="Math.random()"
        />
      </div>
    </div>
    <div
      class="trip-btn-wraper"
      v-if="canEdit"
      >
      <a class="trip-default-btn" @click="openExtraInformationForRide(null)">{{ t('addRideGeneralInfo') }} <span>+</span></a>
    </div>
  </div>
</template>

<script>
import { translationMixin } from "@/mixins/translationMixin";
import CollapseText from "@/components/CollapseText";
import { rideGeneralInfoMixin } from "./rideGeneralInfoMixin";

// The ride's "general information" notes, with add / edit for its author.
export default {
  name: 'RideGeneralInfo',
  mixins: [translationMixin, rideGeneralInfoMixin],
  components: { CollapseText },
  props: {
    ride: { type: Object, required: true },
  },
};
</script>

<style scoped>
.extra-information-title {
  font-size: 22px !important;
  padding: 20px;
  font-weight: 600;
  color: black;
}

.main-ride-titles {
  margin: 2rem 1.5rem !important;
  padding: 1rem 0 !important;
}

@media (max-width: 768px) {
  .main-ride-titles {
    font-size: 2.8rem !important;
    margin: 1.5rem 1rem !important;
    padding: 0.75rem 0 !important;
  }
}

@media (max-width: 480px) {
  .main-ride-titles {
    font-size: 2.6rem !important;
    margin: 1rem 0.75rem !important;
    padding: 0.5rem 0 !important;
  }
}

/* Make trip-default-btn buttons smaller on desktop/full screen */
@media (min-width: 1200px) {
  a.trip-default-btn {
    font-size: 16px !important;
    padding: 12px !important;
    line-height: 20px !important;
  }
}

/* Medium screens - slightly smaller than default */
@media (min-width: 768px) and (max-width: 1199px) {
  a.trip-default-btn {
    font-size: 18px !important;
    padding: 14px !important;
    line-height: 24px !important;
  }
}
</style>
